import { EnvironmentProviders, inject, Injectable, makeEnvironmentProviders } from '@angular/core';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBar } from '@angular/material/snack-bar';

import { Snackbar } from './snackbar.interface';

@Injectable()
export class SnackbarService {
  private snackBar = inject(MatSnackBar);

  open(message: string, action?: string): Snackbar {
    return this.snackBar.open(message, action);
  }
}

export const provideSnackbar = (): EnvironmentProviders => makeEnvironmentProviders([
  SnackbarService,
  { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 4000 } },
]);
